import update from 'immutability-helper';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { PATH_KEY_TO_POSITION } from '../../constants';
import {
  DispatchContext,
  StateContext,
} from '../../contexts/use-menu-editor-context';
import AddButton from '../shared/AddButton';
import BottomControls from '../shared/BottomControls';
import CategoryEditor from './category-editor';
import CategoryItem from './category-item';

const LEVEL = PATH_KEY_TO_POSITION['categoryIdx'];

const ListContainer = styled.div``;

function CategoryList(props) {
  const {
    menuIdx,
    showEditor = false,
    parent,
    setIsEditMode,
    isEditMode,
    isExpanded,
    setIsExpanded,
  } = props;

  // @todo - de-duplicate
  const [showCategoryEditor, setShowCategoryEditor] = useState(showEditor);
  const toggleEditor = () => {
    setShowCategoryEditor(!showCategoryEditor);
    setIsEditMode(!showCategoryEditor);
  };
  const [isUpdatingCategoryOrder, setIsUpdatingCategoryOrder] = useState(false);

  const context = useContext(StateContext);
  const dispatch = useContext(DispatchContext);

  const {
    state: { menus },
    client,
  } = context;

  const setCategories = async newCategories => {
    const menusCloned = [...menus];
    menusCloned[menuIdx].children = newCategories;

    dispatch({ type: 'FETCH_MENUS_RESPONSE', payload: menusCloned });
    setIsUpdatingCategoryOrder(true);

    try {
      const categoryPositions = newCategories.map(newCategory => {
        const menuObj = {
          state: 'reposition',
          menu: {
            id: newCategory.id,
            position: newCategories.indexOf(newCategory),
          },
        };
        return menuObj;
      });

      await client.post('/menu-operations', categoryPositions);
    } catch (err) {
      const oldMenus = [...menus];
      console.log(err);
      dispatch({ type: 'FETCH_MENUS_RESPONSE', payload: oldMenus });
    } finally {
      setIsUpdatingCategoryOrder(false);
    }
  };

  const reorderCards = result => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    if (result.source && !!result.destination) {
      if (result.destination.index === result.source.index) {
        return;
      }
      const dragCard = parent.children[result.source.index];
      const newCategories = update(parent.children, {
        $splice: [
          [result.source.index, 1],
          [result.destination.index, 0, dragCard],
        ],
      });
      setCategories(newCategories);
    }
  };
  const grid = 0;
  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: 0 * grid,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: 'white',

    // styles we need to apply on draggables
    ...draggableStyle,
  });
  const isAnyChildItemExpanded = (parent.children || []).some(category => {
    return Boolean(isExpanded[category.id]);
  });

  return (
    <ListContainer>
      <DragDropContext onDragEnd={reorderCards}>
        <Droppable droppableId="droppable-category">
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {(parent.children || []).map((category, idx) => {
                return (
                  <Draggable
                    key={category.id}
                    draggableId={category.id}
                    index={idx}
                    isDragDisabled={
                      isUpdatingCategoryOrder ||
                      showCategoryEditor ||
                      isEditMode ||
                      isAnyChildItemExpanded
                    }
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        <CategoryItem
                          key={`category-item-${category.id}`}
                          menuIdx={menuIdx}
                          categoryIdx={idx}
                          category={category}
                          parent={parent}
                          setIsEditMode={setIsEditMode}
                          isEditMode={isEditMode}
                          isUpdatingCategoryOrder={isUpdatingCategoryOrder}
                          isExpanded={isExpanded}
                          setIsExpanded={setIsExpanded}
                          isAnyChildItemExpanded={isAnyChildItemExpanded}
                        />
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      {showCategoryEditor ? (
        <CategoryEditor
          parent={parent}
          level={LEVEL}
          menuIdx={menuIdx}
          onCancel={toggleEditor}
          setShowEditor={setShowCategoryEditor}
        />
      ) : (
        <BottomControls level={LEVEL}>
          <AddButton onClick={toggleEditor}>Add a Category</AddButton>
        </BottomControls>
      )}
    </ListContainer>
  );
}

CategoryList.propTypes = {
  parent: PropTypes.object.isRequired,
  menuIdx: PropTypes.number.isRequired,
  showEditor: PropTypes.bool,
};

export default CategoryList;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/CategoryList/category-list.jsx